module.exports = __webpack_public_path__ + "img/13.5f5df833.svg";